import { reactLocalStorage } from "reactjs-localstorage";
import Constants from "../../../util/Constants";
import React from "react";
import DailySalesReportAPI from "../../../api/DailySalesReportAPI";
import { Button, Table } from "react-bootstrap";
import ApiUiController from "../../../controller/ApiUiController";
import { CSVLink } from "react-csv";
import { FaFilter } from "react-icons/fa";
import ChartComponent from "../FixedReportChart";
import FilterPannel from "../../filter/FilterPannel";




class LeadUntouchedBySalesExecutive extends React.Component {
  constructor(props) {
    super(props);
    const model = reactLocalStorage.getObject(Constants.Model)
    const userOptions = model.user.options || [];
    this.fields = model.lead.fields;
    this.loggedInUserId = reactLocalStorage.getObject(Constants.LoggedInUser).user_id;
    this.state = {
      progressData: [],
      userOptions,
      filters: [{
        field: "responsible_person",
        condition: "in",        
        value: `~${this.loggedInUserId}~`,
      },{  
        field: "last_call_feedback",
        condition: "empty",
        value: "",
      }],
      dataSums:[],
      inApiCall: false,
      isFilterOpen: true,
      exportData: [],
    };
  }

  componentDidMount(l) {
    this.fetchApi(this.state.filters,this.onSuccess, this.onFail);
  }


 fetchApi = (filters,onSuccess, onFail) => {
    const body = {
      filters : filters,
      model: "lead_model",
      x:"responsible_person",
      y:"",
      z:"COUNT(id)"
    }
    this.setState({inApiCall: true})
    DailySalesReportAPI.getFixedReport(body, onSuccess, onFail);
  };


  onSuccess =(data)=>{
    // creating blank object and filling 0 to each progress index
    const dataSums = this.state.userOptions.reduce((sums, option) => {
      sums[option.value] = 0;
      return sums;
    }, {});
    // inserting data in specific responsible  id 
    data.forEach((item) => {
      const userIds = item.responsible_person?.split("~").filter(Boolean); 
  
      if (userIds) {
        userIds.forEach((userId) => {
          // Asccumulate the sum for each product ID
          if (dataSums[userId] !== undefined) {
            dataSums[userId] += item.sum;  
          }
        });
      }
    });
    const exportData = this.mapDataForExport(dataSums);
    this.setState({ exportData ,dataSums , inApiCall: false  });  
  }

  onFail = (err) =>{
    console.log("Failed to fetch data" , err);
  }

  toggleFilter = () => {
    this.setState((prevState) => ({
      isFilterOpen: !prevState.isFilterOpen,
    }));
  };

  onFilterChange = (updatedFilters) => {
    this.setState({ filters: updatedFilters },    
     this.fetchApi(this.state.filters,this.onSuccess, this.onFail));
  };

   mapDataForExport = (dataSum) => {
     const exportData = [];
     this.state.userOptions.map(({name , value })=>{
      exportData.push({user : name , total : dataSum[value]});
      return null;
     })
     return exportData;
   }
   
  render(){
    const {exportData , filters ,isFilterOpen , inApiCall , dataSums , userOptions} = this.state;
    let selectedUserId , filteredUserOptions; 
    this.state.filters.map(filter => filter.field === 'responsible_person' ?  selectedUserId = filter.value.split(Constants.Opt).filter(Boolean) : null);
    filteredUserOptions = userOptions.filter(user => { 
      if (Boolean(selectedUserId)) {
        return selectedUserId?.some(id => parseInt(id) === user.value);
      }
      return true;
    });
    const totalSum = filteredUserOptions.reduce((sum , usr)=>{
    const id = usr.value ;
    return sum + dataSums[id];
    },0)

    const table = (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>User</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        {filteredUserOptions.map((option, index) => (
          <tr key={index}>
            <td>{option.name}</td>
            <td>{dataSums[option.value]}</td>
          </tr>
        ))}
        <tr>
          <td>
            <strong>Total</strong>
          </td>
          <td>
            <strong>{totalSum}</strong>
          </td>
        </tr>
      </tbody>
    </Table>);

  return (
        <ApiUiController inApiCall={inApiCall}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-6">
                  <h1>Lead Untouched By Sales Executive</h1>
                </div>
                <div className="col-md-6">
                  <CSVLink data={exportData} filename={`lead_untouched_by_sales_executive_report.csv`}>
                    <Button className="buttons btn-success">Export</Button>
                  </CSVLink>
                </div>
              </div>s
            </div>
            <div className="col-md-4 pt-1">
              <div className="row filterrow">
                <div className="col-md-12 lastcol">
                  <div className="m-right">
                    <div className="btn btn-lead btn-sm filter-button" onClick={this.toggleFilter}>
                      <FaFilter />
                      <span className="badge badge-danger badge-mini rounded-circle">
                        {this.state.filters.length}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row pt-3">
            <div className="container-fluid">
              <div className="row">
                <div className={`col-md-${isFilterOpen ? 9 : 12}`}>
                  <ChartComponent
                    progressSums={dataSums}
                    progressOptions={filteredUserOptions}
                    type="bar"
                  />
                  <div className="col-md-12">{table}</div>
                </div>
                {this.state.isFilterOpen && (
                  <FilterPannel
                    filters={filters}
                    fields={this.fields}
                    onFilterChange={this.onFilterChange}
                    isFilterOpen={isFilterOpen}
                    restrict={false}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </ApiUiController>
    )}}


export default LeadUntouchedBySalesExecutive;

